import App from 'app/App';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<StrictMode>
		<App />
	</StrictMode>
);
